import type { ImgHTMLAttributes } from "react";

export const SBOT_BRAND_LOGO_URL =
  "https://firebasestorage.googleapis.com/v0/b/sbot-labs-app.firebasestorage.app/o/logosAndBranding%2FSBot%20Icon%20White.svg?alt=media&token=138d0d7e-4c1b-4059-99d9-e977f99ba023";

type SBotBrandLogoProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "alt" | "src">;

export function SBotBrandLogo(props: SBotBrandLogoProps) {
  return <img {...props} src={SBOT_BRAND_LOGO_URL} alt="" aria-hidden="true" draggable={false} />;
}
